// hooks/useTranslation.js
import { useState, useEffect } from 'react';
import { translations } from '../translations';

export const useTranslation = () => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('language') || 'tr';
  });

  useEffect(() => {
    const handleLanguageChange = (event) => {
      console.log('useTranslation: Language change detected:', event.detail.language);
      setCurrentLanguage(event.detail.language);
    };

    const handleStorageChange = (event) => {
      if (event.key === 'language' && event.newValue) {
        console.log('useTranslation: Storage change detected:', event.newValue);
        setCurrentLanguage(event.newValue);
      }
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const t = (key) => {
    const translation = translations[currentLanguage]?.[key] || 
                       translations['tr'][key] || 
                       key;
    
    
    return translation;
  };

  return { 
    t, 
    currentLanguage,
    language: currentLanguage
  };
};